import { useState } from "react";
import {
  Box,
  TextField,
  Grid,
  Stack,
  Paper,
  Snackbar,
  Alert,
} from "@mui/material";
import axios from "../../../config/axios.js";
import CommonDialog from "../../../components/CommonDialog.js";
import FormLabel from "../../../components/FormLabel.js";
import Button from "../../../components/CommonButton.js";

const AddNRModal = (props) => {
  const [nationality, setNationality] = useState("");
  const [religion, setReligion] = useState("");
  const [validations, setValidations] = useState({});
  const [alertMsg, setAlertMsg] = useState({});

  // API Services //
  const addReligion = () => {
    const body = {
      name: religion,
    };

    axios
      .post("/admin/religions", body)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.status) {
            setAlertMsg({ status: true, msg: "Religion added successfully!" });
            setReligion("");
            props.fetchReligionOptions();
          } else {
            if (res.data.type === "validation" && res.data.error) {
              const tempValidation = {};
              res.data.error.forEach((val) => {
                tempValidation.religion = { status: true, msg: val.message };
              });
              setValidations((prevState) => ({
                ...prevState,
                ...tempValidation,
              }));
            }
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const addNationality = () => {
    const body = {
      name: nationality,
    };

    axios
      .post("/admin/nationalities", body)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.status) {
            setAlertMsg({
              status: true,
              msg: "Nationality added successfully!",
            });
            setNationality("");
            props.fetchNationalityOptions();
          } else {
            if (res.data.type === "validation" && res.data.error) {
              const tempValidation = {};
              res.data.error.forEach((val) => {
                tempValidation.nationality = { status: true, msg: val.message };
              });
              setValidations((prevState) => ({
                ...prevState,
                ...tempValidation,
              }));
            }
          }
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <CommonDialog
      open={props.open.addNR}
      title={"Add Nationality/Religion"}
      // onSubmit={handleSubmit}
      onClose={() => props.setOpen({ ...props.open, addNR: false })}
    >
      <Paper style={{ ...props.style, width: "100%" }} elevation={0}>
        <Box sx={{ padding: "10px" }}>
          <Stack spacing={2}>
            <Grid container spacing={2}>
              <Grid xs={12} sm={12} md={12} lg={12} xl={12} item>
                <Grid container spacing={1}>
                  <Grid xs={9} sm={9} md={9} lg={9} xl={9} item>
                    <FormLabel title="Nationality" />
                    <TextField
                      size="small"
                      placeholder={"Nationality"}
                      error={validations.nationality?.status}
                      value={nationality}
                      helperText={validations.nationality?.msg}
                      onChange={(e) => {
                        if (validations.nationality?.status) {
                          setValidations((prevState) => ({
                            ...prevState,
                            nationality: { status: false, msg: "" },
                          }));
                        }
                        setNationality(e.target.value);
                      }}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    xs={3}
                    sm={3}
                    md={3}
                    lg={3}
                    xl={3}
                    item
                    sx={{
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "flex-end",
                    }}
                  >
                    <Button onClick={addNationality}>Add</Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid xs={12} sm={12} md={12} lg={12} xl={12} item>
                <Grid spacing={1} container>
                  <Grid xs={9} sm={9} md={9} lg={9} xl={9} item>
                    <FormLabel title="Religion" />
                    <TextField
                      size="small"
                      placeholder={"Religion"}
                      error={validations.religion?.status}
                      value={religion}
                      helperText={validations.religion?.msg}
                      onChange={(e) => {
                        if (validations.religion?.status) {
                          setValidations((prevState) => ({
                            ...prevState,
                            religion: { status: false, msg: "" },
                          }));
                        }
                        setReligion(e.target.value);
                      }}
                      style={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    xs={3}
                    sm={3}
                    md={3}
                    lg={3}
                    xl={3}
                    item
                    sx={{
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "flex-end",
                    }}
                  >
                    <Button onClick={addReligion}>Add</Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Stack>
        </Box>
      </Paper>

      <Snackbar
        open={alertMsg.status}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={2000}
        onClose={() => setAlertMsg({})}
      >
        <Alert severity={alertMsg.severity} sx={{ width: "100%" }}>
          {alertMsg.msg}
        </Alert>
      </Snackbar>
    </CommonDialog>
  );
};

export default AddNRModal;
